import { render, staticRenderFns } from "./MyQuestionBank.vue?vue&type=template&id=5ff0be8d&"
import script from "./MyQuestionBank.vue?vue&type=script&lang=js&"
export * from "./MyQuestionBank.vue?vue&type=script&lang=js&"
import style0 from "./MyQuestionBank.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports